@if (!carregando) {
  <div class="container-fluid p-0" [@esvanecerDesvanecer]="'in'">
    <!-- Título -->
    <div class="borda_inferior bg-light pt-3 pr-4 pb-3 pl-4">
      <div class="d-flex flex-wrap justify-content-between">
        <div class="flex-grow-1 titulo_texto_posicao">
          @if (automacaoEventoMensagem == null) {
            <div class="titulo_texto">Nova Mensagem (Automação)</div>
          }
          @if (automacaoEventoMensagem != null) {
            <div class="titulo_texto">Alterar Mensagem (Automação)</div>
          }
        </div>
      </div>
    </div>
    <!-- Dados -->
    <div class="pt-3 pr-4 pb-4 pl-4">
      <form [formGroup]="formDados" (ngSubmit)="salvar()">
        <div class="form-row">
          <div class="form-group col-sm-4">
            <label><b>Tipo:</b></label>
            <select class="form-control form-control-sm" name="automacao_evento_tipo" #automacao_evento_tipo (change)="selecionarAutomacaoEventoTipo(automacao_evento_tipo.value)">
              @for (opcao of automacaoEventosTipos; track opcao) {
                <option [value]="opcao.id" [selected]="automacaoEventoTipoSelecionado != null ? opcao.id == automacaoEventoTipoSelecionado.id : null">{{ opcao.nome_tipo }}</option>
              }
            </select>
          </div>
        </div>
        <div class="form-row">
          <div class="form-group col-sm-8">
            <label><b>Mensagem:</b></label>
            <textarea class="form-control form-control-sm" type="text" rows="4" name="mensagem" [ngClass]="{ 'is-invalid': enviado && f.mensagem.errors?.required }" formControlName="mensagem"></textarea>
            @if (enviado && f.mensagem.errors?.required) {
              <div class="erro pt-1">Mensagem em branco!</div>
            }
          </div>
          <div class="form-group col-sm-4">
            <label><b>Variáveis:</b></label>
            <select class="form-control form-control-sm" name="automacao_evento_tipo_variaveis" #automacao_evento_tipo_variaveis (change)="selecionarAutomacaoEventoTipoVariaveis($event, automacao_evento_tipo_variaveis.value)">
              <option value="0"></option>
              @for (opcao of automacaoEventosTiposVariaveis; track opcao) {
                <option [value]="opcao.id" [selected]="automacaoEventoTipoVariaveisSelecionado != null ? opcao.id == automacaoEventoTipoVariaveisSelecionado.id : null">{{ opcao.variavel }}</option>
              }
            </select>
          </div>
        </div>
        <hr class="mt-2 mb-2" />
        <div class="d-flex flex-wrap justify-content-between">
          <div class="flex-grow-1 text-right">
            <button class="btn btn-success btn_formulario" type="submit">Salvar</button>
          </div>
        </div>
      </form>
    </div>
  </div>
}
